import { createProjectDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createProjectCallable = getCallable(createProjectDefinition);
